import React from "react";

import { DataGrid, GridToolbarQuickFilter } from "@mui/x-data-grid";
import Box from "@mui/material/Box";

import { useTranslation } from "react-i18next";

function QuickSearchToolbar() {
    return (
        <Box
            sx={{
                p: 0.5,
                pb: 0,
            }}
        >
            <GridToolbarQuickFilter />
        </Box>
    );
}

export default function Basic(props) {
    const { t } = useTranslation();
    let userAttributes = [];

    if (props.operatorKeypoolList !== undefined) {
        for (const key of Object.keys(props.operatorKeypoolList)) {
            userAttributes.push({
                id: key,
                keypoolKey: key,
                ssid: props.operatorKeypoolList[key]["ssid"],
                scope: props.operatorKeypoolList[key]["Scope"],
                AuthenticationMechanism:
                    props.operatorKeypoolList[key]["AuthenticationMechanism"],
                connectedVenueCount:
                    props.operatorKeypoolList[key]["ConnectedVenueCount"],
                KeyCount: props.operatorKeypoolList[key]["KeyCount"],
                SubscriberCount:
                    props.operatorKeypoolList[key]["SubscriberCount"],
                InactiveSubscriberCount:
                    props.operatorKeypoolList[key]["InactiveSubscriberCount"],
                displayOrder: props.operatorKeypoolList[key]["DisplayOrder"],
                dateAdded: Intl.DateTimeFormat("en-CA", {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                    hour: "numeric",
                    minute: "numeric",
                }).format(
                    new Date(
                        props.operatorKeypoolList[key]["dateAddedUTC.ISO8601"]
                    )
                ),
            });
        }
    }

    const columns = [
        {
            headerName: "SSID",
            field: "ssid",
            flex: 0.2,
            minWidth: 150,
        },
        {
            headerName: "Scope",
            field: "scope",
            flex: 0.15,
            minWidth: 120,
        },
        {
            headerName: "Auth Mechanism",
            field: "AuthenticationMechanism",
            flex: 0.2,
            minWidth: 150,
        },
        {
            headerName: "Connected Venues",
            field: "connectedVenueCount",
            flex: 0.15,
            minWidth: 140,
        },
        {
            headerName: "Key Count",
            field: "KeyCount",
            flex: 0.1,
            minWidth: 100,
        },
        {
            headerName: "Subscriber Count",
            field: "SubscriberCount",
            flex: 0.15,
            minWidth: 140,
        },
        {
            headerName: "Inactive Subscriber Count",
            field: "InactiveSubscriberCount",
            flex: 0.15,
            minWidth: 180,
        },
        {
            headerName: "Display Order",
            field: "displayOrder",
            flex: 0.1,
            minWidth: 120,
        },
        {
            headerName: "Date Added",
            field: "dateAdded",
            flex: 0.2,
            minWidth: 160,
        },
    ];

    return (
        <div style={{ height: 400, width: "100%" }}>
            <DataGrid
                rows={userAttributes}
                columns={columns}
                hideFooterPagination={false}
                hideFooter={false}
                onRowClick={(params) =>
                    props.getKeypoolInfo(params.row.keypoolKey)
                }
                slots={{ toolbar: QuickSearchToolbar }}
                disableRowSelectionOnClick={true}
                localeText={{
                    noRowsLabel: t("recentservice.nomatches"),
                }}
                initialState={{
                    sorting: {
                        sortModel: [{ field: "displayOrder", sort: "asc" }],
                    },
                }}
                sx={{
                    "& .MuiDataGrid-row:hover": {
                        cursor: "pointer",
                    },
                }}
            />
        </div>
    );
}

